import { useState } from "react";
import ApiService from "../../services/ApiServiceClass";

export type CategoryTypeType = {
    id: number,
    name: string
}

type TransformedCategoryType = {
    id: string,
    value: string
}

export const useCategoryTypeForRadio = () => {
    const [categoryTypesForRadio, setCategoryTypesForRadio] = useState<TransformedCategoryType[]>([]);

    const fetchCategoryTypes = async () => {

        try {
            const responseData = await ApiService.getCategoryTypes();
            let transforedData = [];
            if (responseData.data) {
                transforedData = responseData.data.map((item: CategoryTypeType) => ({
                    id: item.id,
                    value: item.name
                }));
            }            
            setCategoryTypesForRadio(transforedData);
        } catch (error) {
            throw(error);
        }
    }

    return { categoryTypesForRadio, setCategoryTypesForRadio, fetchCategoryTypes };
}